export const createEvent = (selectedDate: Date, type = "Inspection") => {
  const startDate = new Date(selectedDate);
  const endDate = new Date(startDate.getTime() + 15 * 60 * 1000);
  const formatDateForICS = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, "").split(".")[0];
  };

  const formattedStartDate = formatDateForICS(startDate);
  const formattedEndDate = formatDateForICS(endDate);

  const expectedArrivalDate = selectedDate ? new Date(selectedDate) : null;
  const formattedExpectedArrival = expectedArrivalDate
    ? expectedArrivalDate.toLocaleDateString()
    : "Date not available";

  const icsContent = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${new Date().getTime()}@flowautobody.com`,
    `SUMMARY:Flow Autobody ${
      type === "Inspection" ? "Inspection" : "Repair"
    } Booking`,
    `DTSTAMP:${formatDateForICS(new Date())}`,
    `DTSTART:${formattedStartDate}Z`,
    `DTEND:${formattedEndDate}Z`,
    `DESCRIPTION:${type} scheduled for ${formattedExpectedArrival}`,
    "LOCATION:2C 256 S Pine Rd, Enoggera QLD 4051",
    "STATUS:CONFIRMED",
    "SEQUENCE:0",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const link = document.createElement("a");
      link.href = reader.result as string;
      link.download = "event.ics";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    reader.readAsDataURL(blob);
  } else {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "event.ics";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
